// 异业合作渠道配置
// userSource 必须与服务端 UserSourceEnum 的枚举名一致
//
// entryBg    入口页整屏长图海报(750x3723), 按宽度等比缩放、页面自然滚动
// entryBtn   入口页吸底按钮图(750x300, 四周透明, 可见按钮 x123~620 / y98~189)
//            换按钮图时若可见区域位置变了, 要同步改 Entry.vue 里热区的百分比。
// loginBg    登录页整屏底图(750x1350, 顶行纯色 #2D5988, 屏幕更高时用它补色)
//            原素材是 PNG 存照片(1.1MB), 已转 progressive JPEG(84KB)
// loginTitle 登录页标题组图(750x276, 白字透明底, 内容 x220~537 / y88~195)
// successBg  成功页长图海报(750x9147)
// successBtn 成功页按钮图(750x300, 四周透明, 可见按钮 x107~631 / y91~197), 压在长图底部
// 人保暂用平安的图, 素材到位后改这几行即可, 组件不用动。
export const PARTNERS = {
  pingan: {
    userSource: 'PINGAN',
    name: '平安',
    entryBg: require('@/assets/img/coop/pingan_entry_bg.jpg'),
    entryBtn: require('@/assets/img/coop/entry_btn.png'),
    loginBg: require('@/assets/img/coop/pingan_login_bg.jpg'),
    loginTitle: require('@/assets/img/coop/login_title.png'),
    successBg: require('@/assets/img/coop/pingan_success_bg.jpg'),
    successBtn: require('@/assets/img/coop/success_btn.png')
  },
  picc: {
    userSource: 'PICC',
    name: '人保',
    entryBg: require('@/assets/img/coop/pingan_entry_bg.jpg'),
    entryBtn: require('@/assets/img/coop/entry_btn.png'),
    loginBg: require('@/assets/img/coop/pingan_login_bg.jpg'),
    loginTitle: require('@/assets/img/coop/login_title.png'),
    successBg: require('@/assets/img/coop/pingan_success_bg.jpg'),
    successBtn: require('@/assets/img/coop/success_btn.png')
  }
}

// 成功页【点击了解新世代车型】目标地址
export const BMW_NEW_GENERATION_URL = 'https://www.bmw.com.cn/zh/all-models/bmw-i/ix3/2026/inspire.html'

export function getPartner(code) {
  return PARTNERS[code] || null
}
